import React from 'react';

import Text from 'ui/Text';
import { ErrorMessageWrapper, WarningIcon } from 'features/Betslip/styled';

const ValidationMessage = ({ message, wrapperStyles, className }) => {
    return (
        <ErrorMessageWrapper style={wrapperStyles} className={className}>
            <WarningIcon>
                <Text
                    condensed
                    size="x15"
                    color="#FBF5E5"
                    padding="0"
                    align="center"
                >
                    !
                </Text>
            </WarningIcon>
            <Text condensed size="x1" color="#333333" padding="0">
                {message}
            </Text>
        </ErrorMessageWrapper>
    );
};

export default ValidationMessage;
